const access = {
  entities: [
    { label: 't(Domains)', code: 'domains' }
  ], 
  rights: [] 
}

export default access
